import PropTypes from 'prop-types';
import { UnderlinedButton } from 'jl-design-system/elements/button/Button';

import styles from '../AddressQuestion.scss';

export const AddLineButton = ({ onClickHandler }) => (
  <UnderlinedButton onClick={onClickHandler} className={styles.AddressQuestion__addLineBtn}>
    Add address line
  </UnderlinedButton>
);

AddLineButton.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
};
